import { render, staticRenderFns } from "./setting-lao-etax.vue?vue&type=template&id=3331f881"
import script from "./setting-lao-etax.vue?vue&type=script&lang=js"
export * from "./setting-lao-etax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports